module.exports = "/static/images/location-pin-solid.svg";